import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineBriefcaseIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 6h-4V5a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v1H3a1 1 0 0 0-1 1v4a3 3 0 0 0 1 2.22V19a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5.78A2.9993 2.9993 0 0 0 22 11V7a1.0002 1.0002 0 0 0-1-1ZM9 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1H9V5Zm10 14a1.0001 1.0001 0 0 1-1 1H6a1.0002 1.0002 0 0 1-1-1v-5h2v1a1 1 0 1 0 2 0v-1h6v1a1.0001 1.0001 0 0 0 2 0v-1h2v5Zm1-8a1.0001 1.0001 0 0 1-1 1h-2v-1a1.0001 1.0001 0 0 0-2 0v1H9v-1a1 1 0 1 0-2 0v1H5a1.0002 1.0002 0 0 1-1-1V8h16v3Z"/>
  </SvgIcon>
}

export default LineBriefcaseIcon
